import styled from 'styled-components';
import { CFBaseAccordionStyles, } from '@connectrn/ds-ui-base';
export const CFAccordionElements = {
    Divider: styled.div `
    ${CFBaseAccordionStyles.Divider}
  `,
    Panel: styled.div `
    ${CFBaseAccordionStyles.Panel}
  `,
    Root: styled.div `
    ${CFBaseAccordionStyles.Root}
    ${CFBaseAccordionStyles.RootWeb}
  `,
    Trigger: styled.button `
    ${CFBaseAccordionStyles.Trigger}
  `,
    TriggerIconWrapper: styled.div `
    ${CFBaseAccordionStyles.TriggerIconWrapper}
    ${CFBaseAccordionStyles.TriggerIconWrapperWeb}
  `,
    TriggerLabel: styled.div `
    ${CFBaseAccordionStyles.TriggerLabel}
  `,
    TriggerRoot: styled.div `
    ${CFBaseAccordionStyles.TriggerRoot}
    ${CFBaseAccordionStyles.TriggerRootWeb}
  `,
};
